import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';
import { removeAuthenticated } from 'utils/authentication';
import { getStoredSpaceId } from 'contexts/space';

const createApolloClient = (graphQLServerUrl) => {
  const uploadLink = new UploadHttpLink({
    uri: graphQLServerUrl,
    credentials: 'include',
  });

  const spaceLink = new ApolloLink((operation, forward) => {
    const spaceId = getStoredSpaceId();
    if (spaceId) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          'X-Space-Id': spaceId,
        },
      }));
    }
    return forward(operation);
  });

  const errorLink = new ErrorLink(({ result }) => {
    if (result && result.errors) {
      result.errors.forEach(({ message }) => {
        if (message === 'Please authorize') {
          removeAuthenticated();
        }
      });
    }
  });

  const client = new ApolloClient({
    link: ApolloLink.from([errorLink, spaceLink, uploadLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
      },
    },
  });

  return client;
};

export default createApolloClient;
